import InfoUserForm from '@/ui/components/user/InfoUserForm';

import UserOptionsContainer from '@/ui/containers/userOptions/UserOptionsContainer';
import { useEffect } from 'react';


/** Componente pagina User/Info
 * @component
 */
const UserInfo = (): JSX.Element => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <UserOptionsContainer type='content-info' >
      <InfoUserForm />
    </UserOptionsContainer>
  );
};

export default UserInfo;
